import { Component, computed, input } from '@angular/core';
import { Block } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-hero-overlay-layout',
    standalone: false,
    templateUrl: './hero-overlay-layout.component.html',
    styleUrl: './hero-overlay-layout.component.scss',
})
export class HeroOverlayLayoutComponent {
    block = input.required<Block>();
    hasCustomHeadingTypography = input<boolean>(false);
    hasCustomDescriptionTypography = input<boolean>(false);

    heroContainerStyles = computed(() => ({
        '--hero-bg-image': `url(${this.block().data.image})`,
        ...(this.block().data.includeScrim && {
            '--hero-scrim-color': this.block().data.scrimColor,
        }),

        '--hero-container-min-height--mobile': this.block().data.bannerMinHeightMobile,
        '--hero-container-min-height--tablet': this.block().data.bannerMinHeightTablet,
        '--hero-container-min-height--desktop': this.block().data.bannerMinHeightDesktop,

        ...(this.block().data.useCustomImagePosition && {
            '--hero-bg-image-position--mobile': this.block().data.imagePositionMobile,
            '--hero-bg-image-position--tablet': this.block().data.imagePositionTablet,
            '--hero-bg-image-position--desktop': this.block().data.imagePositionDesktop,
        }),

        ...(this.block().data.useCustomImageSize && {
            '--hero-bg-image-size--mobile': this.block().data.imageSizeMobile,
            '--hero-bg-image-size--tablet': this.block().data.imageSizeTablet,
            '--hero-bg-image-size--desktop': this.block().data.imageSizeDesktop,
        }),
    }));
}
